import styled from 'styled-components';
import colors from '@constants/Colors';

export const Title = styled.p`
  font-size: 20px;
  line-height: 26px;
  font-weight: 300;
  color: ${colors.darkSlate};
  margin: 0;
  transition: color 200ms;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

  @media (max-width: 767px) {
    max-width: 220px;
    text-align: initial;
  }
`;

export const ItemWrapper = styled.li`
  list-style: none;
  border-bottom: 1px solid #e4ecf1;
  padding-bottom: 32px;
  margin-bottom: 32px;

  :last-child {
    margin-bottom: 0;
  }

  :hover ${Title} {
    color: ${colors.periwinkleStrong};
  }

  @media (max-width: 767px) {
    padding-bottom: 16px;
    margin-bottom: 16px;
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;
